import { render, staticRenderFns } from "./AdminNoticeDetail.vue?vue&type=template&id=33928232&scoped=true&lang=pug&"
import script from "./AdminNoticeDetail.vue?vue&type=script&lang=ts&"
export * from "./AdminNoticeDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33928232",
  null
  
)

export default component.exports